import PropTypes from 'prop-types';
import { noop } from 'src/utils/core/event';

export const CapActionPropTypes = {
  action: PropTypes.object,
  allExternalUsersId: PropTypes.array,
  canDonwloadAttachment: PropTypes.bool,
  findingId: PropTypes.number,
  index: PropTypes.number,
  isActionEditible: PropTypes.bool,
  isCapManager: PropTypes.bool,
  isFactoryUser: PropTypes.bool,
  isFindingEditible: PropTypes.bool,
  refetchCapHistories: PropTypes.func,
  removeActionFromCollection: PropTypes.func,
  setActionCache: PropTypes.func,
  setFindingStatusToPending: PropTypes.func,
  isExternalUser: PropTypes.bool.isRequired,
  findingStatus: PropTypes.string.isRequired
};

export const CapActionDefaultProps = {
  allExternalUsersId: [],
  refetchCapHistories: noop
};
